export default __webpack_public_path__ + "static/media/beauty.8d7d981b.png";